// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pintura-sidebar .bx--dropdown-link{height:40px}.pintura-sidebar .bx--list-box--expanded .bx--list-box__menu{max-height:250px}.pintura-sidebar .cv-header.bx--header{z-index:800}", ""]);
// Exports
module.exports = exports;
